import { Link } from "react-router-dom";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { allVideos, getFeatured, getHot, getLatest } from "@/data/videos";
import VideoCard from "@/components/base/VideoCard";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import HotList from "@/pages/home/components/HotList";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useDocumentMeta({
    title: "51无敌电影网-最新电影电视剧在线观看平台",
    description:
      "51无敌电影网提供海量最新电影和电视剧资源，覆盖多种类型，用户可以轻松在线观看各类影视作品，享受优质视听体验。",
    keywords: "51无敌电影网,在线电影,电视剧观看,最新电影,影视大全,免费播放电影,影视频道",
  });

  const featured = getFeatured(4);
  const latest = getLatest(10);
  const hotRanking = getHot(8);
  const topRated = [...allVideos].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <>
      <HeroCarousel items={featured} />

      <CategoryEntry />

      <section className="w-full px-4 md:px-6 py-10 md:py-12">
        <SectionHeading
          icon="ri-time-line"
          title="最新更新"
          subtitle="每日同步更新，第一时间掌握热映影视动态"
          moreLink="/category/movie"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {latest.map((item) => (
            <VideoCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-12 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          <div className="lg:col-span-8">
            <SectionHeading
              icon="ri-fire-line"
              title="热门影视推荐"
              subtitle="口碑与热度兼具，精选高分佳作"
              moreLink="/category/tv"
            />
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5">
              {topRated.map((item) => (
                <VideoCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <SectionHeading icon="ri-bar-chart-2-line" title="热播飙升榜" subtitle="按播放量实时排序" />
            <div className="rounded-lg bg-background-50 border border-background-200 p-3 md:p-4">
              <HotList items={hotRanking} />
            </div>
            <Link
              to="/category/movie"
              className="mt-4 flex items-center justify-center gap-2 w-full py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label font-semibold transition-colors cursor-pointer"
            >
              <i className="ri-compass-3-line text-lg"></i>
              浏览全部影视
            </Link>
          </aside>
        </div>
      </section>

      <SiteIntro />
    </>
  );
}